import React, { createContext, useState } from "react";

import { signin as signInApi, register as registerAPI } from "../apis";

import cookies from "js-cookie";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [loading, setLoading] = useState(false);

  const signIn = async (email, password, callback) => {
    setLoading(true);
    const langCode = cookies.get("i18next");

    const response = await signInApi(email, password, langCode);

    if (response && response.auth_token) {
      localStorage.setItem("token", response.auth_token);
      setToken(response.auth_token);
      callback();
    }

    setLoading(false);
  };

  const register = async (name, email, password, callback) => {
    setLoading(true);
    const response = await registerAPI(name, email, password);
    if (response && response.id) {
      callback();
    }
    setLoading(false);
  };

  const signOut = () => {
    localStorage.removeItem("token");
    setToken("");
  };

  const value = {
    token,
    loading,
    signIn,
    signOut,
    register,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthContext;
